var actionSkipLink = function (id) {
    $("#" + id).focus();
    scrollToView(id, 0);
};